import { render, staticRenderFns } from "./ChanPin.vue?vue&type=template&id=010cec71&scoped=true&"
import script from "./ChanPin.vue?vue&type=script&lang=js&"
export * from "./ChanPin.vue?vue&type=script&lang=js&"
import style0 from "./ChanPin.vue?vue&type=style&index=0&id=010cec71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010cec71",
  null
  
)

export default component.exports